module.exports = __webpack_public_path__ + "static/media/4_Standing up on the inside_UAE.73609d11.txt";